import { defineMessages } from 'react-intl';

export default defineMessages({
  legendWaiting: {
    id: 'schedule-calendar.legend.waiting',
    defaultMessage: 'ClassPass clients are waiting for a spot',
  },
  legendNoClasses: {
    id: 'schedule-calendar.legend.no-classes',
    defaultMessage: 'No classes scheduled',
  },
  unsyncedTooltip: {
    id: 'schedule-calendar.unsynced-tooltip',
    defaultMessage: "Classes this far in advance haven't synced from your booking platform yet. Check back later.",
  },
});
